var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstraSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7156_21748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.833 24.7075L28.2692 19.1974L37.5123 8.53057L24.0926 14.5L20.8061 1L17.5685 14.5092L4.08524 8.59945L13.3773 19.2295L0.833008 24.7902L15.0157 25.0795L11.9297 38.0743L20.8306 27.7932L21.6081 28.6703L29.8781 38.111L26.6895 25.0565L40.833 24.7075ZM9.90502 12.8423L18.7081 16.704L20.811 7.91986L22.5668 15.1519L14.8885 18.5545L9.90502 12.8423ZM7.7923 23.4035L28.3718 14.2749L15.7493 23.5641L7.7923 23.4035ZM15.0157 32.059L16.7518 24.7718L29.3793 15.4826L15.0157 32.059ZM26.7531 32.1187L22.6205 27.4213L21.8625 26.581L27.203 20.4234L28.2887 20.8825L33.8688 23.3253L24.6502 23.555L26.7531 32.1187Z",
    fill: "#212737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7156_21748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.833008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstraSmallIcon);
export default __webpack_public_path__ + "static/media/astra_small_icon.ae61f8331414b81e7373fd95808d1f3e.svg";
export { ForwardRef as ReactComponent };